<template>
  <section>
    <gs-header title="Nhân bản bảng giá"
      :breadcrumbs="[
        {title: 'Quản lý bảng giá', route: {name: 'price-table'}}
      ]"
    >
    </gs-header>
    <div class="padding-sm-all">
      <el-form label-position="top" class="margin-top" :rules="rules" ref="create-price-table-form" :model="localPriceTable" label-width="150px" @submit.prevent.native="validatorBeforeSubmit" >
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localPriceTable.name" placeholder="Tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Hãng vận chuyển" class="is-required" prop="carrier_id">
              <el-select class="display-block " v-model="localPriceTable.carrier_id" filterable placeholder="Chọn hãng vận chuyển">
                <el-option
                  v-for="carrier in carriers"
                  :key="carrier.id"
                  :label="carrier.name"
                  :value="carrier.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="8">
            <el-form-item label="Dịch vụ" class="is-required" prop="service_id">
              <el-select class="width-100" v-model="localPriceTable.service_id" filterable placeholder="Chọn dịch vụ">
                <el-option
                  v-for="service in services"
                  :key="service.id"
                  :label="service.name"
                  :value="service.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Mapping id" prop="service_mapping_id">
              <el-select class="width-100" clearable v-model="localPriceTable.service_mapping_id" filterable placeholder="Mapping id">
                <el-option-group
                  v-for="(sGroup, key, index) in priceTableHelpers.services"
                  :label="key"
                  :key="key">
                  <el-option
                    v-for="(service, key, index) in sGroup"
                    :label="service"
                    :value="key"
                    :key="key">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Giờ áp dụng" prop="hour_apply">
              <el-input v-model="localPriceTable.hour_apply" placeholder="Giờ áp dụng">
                <div slot="append">Giờ</div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="adddon-3">
            <el-form-item label="Thời gian dự kiến giao hàng" prop="expected_delivery">
              <el-input type="number" step="any" v-model="localPriceTable.expected_delivery" placeholder="Thời gian dự kiến giao hàng">
                <el-select v-model="localPriceTable.expected_unit" slot="append" placeholder="Select">
                  <el-option
                    v-for="(unit, index) in priceTableHelpers.units"
                    :label="unit"
                    :value="index"
                    :key="index"
                    ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Mô tả dịch vụ" prop="service_description">
              <el-input v-model="localPriceTable.service_description" placeholder="Mô tả dịch vụ">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="TP đi" class="is-required" prop="city_from_id">
              <el-select class="width-100" v-model="localPriceTable.city_from_id" filterable placeholder="Chọn TP đi">
                <el-option
                  v-for="city in cities"
                  :key="city.id"
                  :label="city.name"
                  :value="city.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Vùng miền đến" class="is-required" prop="region_to_id">
              <el-select class="width-100" v-model="localPriceTable.region_to_id" filterable placeholder="Chọn vùng miền đến">
                <el-option
                  v-for="region in regions"
                  :key="region.id"
                  :label="region.name"
                  :value="region.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="6">
            <el-form-item label="Giá" prop="amount">
              <el-input @focus="removeZero('amount')" @blur="addZero('amount')" v-model="localPriceTable.amount" placeholder="Giá">
                <template slot="append"><span class="text-red">{{localPriceTable.amount | vnd}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Phí thu hộ tối thiểu" prop="cod_min_fee">
              <el-input @focus="removeZero('cod_min_fee')" @blur="addZero('cod_min_fee')" v-model="localPriceTable.cod_min_fee" placeholder="Phí thu hộ tối thiểu">
                <template slot="append"><span class="text-red">{{localPriceTable.cod_min_fee | vnd}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Phí thu hộ (COD)" prop="cod_fee">
              <el-input  @focus="removeZero('cod_fee')" @blur="addZero('cod_fee')" v-model="localPriceTable.cod_fee" placeholder="Phí thu hộ (COD)">
                <template slot="append"><span class="text-red">{{localPriceTable.cod_fee | number(3)}} %</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Giá trị đơn hàng áp dụng" prop="cod_apply">
              <el-input  @focus="removeZero('cod_apply')" @blur="addZero('cod_apply')" v-model="localPriceTable.cod_apply" placeholder="Giá trị đơn hàng áp dụng">
                <template slot="append"><span class="text-red">{{localPriceTable.cod_apply | vnd}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="6">
            <el-form-item label="Cân nặng khởi điểm" prop="weight_first">
              <el-input @focus="removeZero('weight_first')" @blur="addZero('weight_first')" v-model="localPriceTable.weight_first" placeholder="Cân nặng khởi điểm">
                <template slot="append"><span class="text-orange">{{localPriceTable.weight_first | gam}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Cân nặng tối đa" prop="maximum_weight">
              <el-input  @focus="removeZero('maximum_weight')" @blur="addZero('maximum_weight')" v-model="localPriceTable.maximum_weight" placeholder="Cân nặng tối đa">
                <template slot="append"><span class="text-orange">{{localPriceTable.maximum_weight | gam}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Bước nhảy" prop="weight_step">
              <el-input @focus="removeZero('weight_step')" @blur="addZero('weight_step')" v-model="localPriceTable.weight_step" placeholder="Bước nhảy">
                <template slot="append"><span class="text-orange">{{localPriceTable.weight_step | gam}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Giá bước nhảy" prop="weight_step_fee">
              <el-input  @focus="removeZero('weight_step_fee')" @blur="addZero('weight_step_fee')" v-model="localPriceTable.weight_step_fee" placeholder="Giá bước nhảy">
                <template slot="append"><span class="text-red">{{localPriceTable.weight_step_fee | vnd}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12" class="adddon-2">
            <el-form-item label="Phụ phí ngoại thành" prop="location_step_fee">
              <el-input @focus="removeZero('location_step_fee')" @blur="addZero('location_step_fee')" v-model="localPriceTable.location_step_fee" placeholder="Phụ phí ngoại thành">
                <span class="text-red" slot="append">{{localPriceTable.location_step_fee | vnd}}</span>
                <el-select v-model="localPriceTable.lsf_type" slot="prepend" placeholder="Select">
                  <el-option
                    v-for="(lsf_type, key, index) in priceTableHelpers.lsf_types"
                    :label="lsf_type"
                    :value="parseInt(key)"
                    :key="key"
                    ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Phí chuyển hoàn" prop="return_fee">
              <el-input type="number" step="any" @focus="removeZero('return_fee')" @blur="addZero('return_fee')" v-model="localPriceTable.return_fee" placeholder="Phí chuyển hoàn">
                <template slot="append"><span class="text-red">{{ localPriceTable.return_fee | number(3) }} %</span></template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Áp dụng riêng cho khách hàng" prop="apply_only_customer">
              <select-client v-model="localPriceTable.apply_only_customer" />
            </el-form-item>
          </el-col>
          <el-col :span="12" class="adddon-1">

          </el-col>
        </el-row>
        <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
      </el-form>
    </div>
  </section>
</template>

<script>
  import { head } from 'lodash'
  import { getPriceTable, addPriceTable } from 'src/api/pricetable'
  import PriceTableMixin from './mixins'
  import SelectClient from 'src/components/client/SelectClient'
  export default {
    name: 'EditCarrier',
    mixins: [PriceTableMixin],
    components: {SelectClient},
    methods: {
      validatorBeforeSubmit () {
        this.submitting = true
        this.$refs['create-price-table-form'].validate((valid) => {
          if (valid) {
            this.changedData = false
            addPriceTable(this.localPriceTable).then(response => {
              switch (response.code) {
                case 200:
                  this.submitting = false
                  this.$store.dispatch('showNotify', {
                    title: 'Nhân bản thành công',
                    body: 'Nhân bản bảng giá thành công',
                    type: 'success'
                  })
                  this.reloadGsTableAfterRedirect({name: 'price-table'}, 'priceTables')
                  this.toggleLoadding(false)
                  break
                case 422:
                  this.submitting = false
                  let er = response.data.errors
                  let message = head(er[Object.keys(er)[0]])
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng kiểm tra thông tin cần nhập',
                    body: message,
                    type: 'warning'
                  })
                  this.toggleLoadding(false)
                  break
                default:
                  this.submitting = false
                  this.$store.dispatch('showNotify', {
                    title: 'Nhân bản thất bại',
                    body: 'Nhân bản bảng giá thất bại vui lòng kiểm tra lại thông tin',
                    type: 'danger'
                  })
                  this.toggleLoadding(false)
              }
            })
          } else {
            this.submitting = false
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              type: 'warning'
            })
            return false
          }
        })
      }
    },
    mounted () {
      getPriceTable(this.$route.params.id, {include: 'carrier,only_customer'}).then(response => {
        if (response.code === 200) {
          this.localPriceTable.city_id = response.data.city_id
          this.localPriceTable.region_id = response.data.region_id
          this.localPriceTable.service_id = response.data.service_id
          this.localPriceTable.service_description = response.data.service_description
          if (response.data.name.indexOf(' (copy') > 0) {
            let temp = response.data.name.slice(response.data.name.indexOf(' (copy') + 6, response.data.name.indexOf(' (copy') + 7)
            let num = 1
            if (temp !== ')') {
              num = parseInt(temp) + 1
            }
            response.data.name = response.data.name.slice(0, response.data.name.indexOf(' (copy')) + ' (copy' + num + ')'
          } else {
            response.data.name += ' (copy)'
          }
          this.localPriceTable.name = response.data.name
          this.localPriceTable.weight_first = response.data.weight_first
          this.localPriceTable.weight_step = response.data.weight_step
          this.localPriceTable.weight_step_fee = response.data.weight_step_fee
          this.localPriceTable.maximum_weight = response.data.maximum_weight
          this.localPriceTable.location_step_fee = response.data.location_step_fee
          this.localPriceTable.lsf_type = response.data.lsf_type
          this.localPriceTable.cod_apply = response.data.cod_apply
          this.localPriceTable.cod_min_fee = response.data.cod_min_fee
          this.localPriceTable.cod_fee = response.data.cod_fee
          this.localPriceTable.return_fee = response.data.return_fee
          this.localPriceTable.hour_apply = response.data.hour_apply
          this.localPriceTable.expected_unit = response.data.expected_unit
          this.localPriceTable.carrier_id = response.data.carrier.data.id
          this.localPriceTable.city_from_id = response.data.city_id
          this.localPriceTable.region_to_id = response.data.region_id
          this.localPriceTable.expected_delivery = response.data.expected_delivery.toString()
          this.localPriceTable.service_mapping_id = response.data.service_mapping_id ? response.data.service_mapping_id.toString() : undefined
          this.localPriceTable.amount = response.data.amount.toString()
          this.localPriceTable.apply_only_customer = response.data.apply_only_customer ? response.data.only_customer.data.id : ''
          setTimeout(() => {
            this.watching = true
          }, 100)
        } else {
          this.$router.push({name: 'price-table'})
          this.$store.dispatch('showNotify', {
            title: 'Không tìm thấy tài nguyên',
            body: 'Bảng giá không tồn tại trên hệ thống',
            type: 'warning'
          }, {root: true})
        }
      })
    }
  }
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// CopyPriceTable.vue?3d8c349f